import React from "react";
import styled from "styled-components"; 

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #ffc734, #ff9f1c);
  color: #2c2e35;
`;

const Card = styled.div`
  text-align: center;
  padding: 60px 40px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 15px 40px rgba(0,0,0,0.2);
  max-width: 500px;
  width: 90%;
`;

const Title = styled.h1`
  font-size: 120px;
  margin: 0;
  font-weight: 900;
  color: #f4ae4c;
`;

const Subtitle = styled.h2`
  margin-top: 10px;
  font-size: 28px;
`;

const Text = styled.p`
  margin: 15px 0 30px;
  font-size: 16px;
  color: #555;
`;

const Button = styled.a`
  display: inline-block;
  padding: 12px 30px;
  background: #ff9f1c;
  color: white;
  font-weight: 600;
  border-radius: 30px;
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    background: #e88b0d;
    transform: translateY(-2px);
  }
`;

const Notfound = () => {
  return (
    <Wrapper>
      <Card>
        <Title>404</Title>
        <Subtitle>Page Not Found</Subtitle>
        <Text>
          Oops! The page you are looking for doesn't exist or has been moved.
        </Text>
        <Button href="/">Back to Home</Button>
      </Card>
    </Wrapper>
  );
};

export default Notfound;